'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('./utils-40e27a2a.js');
var react = require('react');

const useDeprecationMiddleware = (currentAccount, currentUser, { projectName, deprecationManifestForDev }) => {
    const { pathname } = window.location;
    const [manifest, setManifest] = react.useState(deprecationManifestForDev);
    react.useEffect(() => {
        utils.debugLog('Project name:', projectName);
        if (!manifest) {
            utils.debugLog('Fetching deprecation manifest');
            utils.fetchDeprecationManifest().then(setManifest);
        }
    }, [manifest, setManifest]);
    react.useEffect(() => {
        utils.debugLog(`Transition url: ${pathname}`);
        utils.checkUrlForDeprecation({ toUrl: pathname, currentAccount, currentUser, manifest, params: {} });
    }, [pathname, currentAccount, currentUser, manifest, utils.checkUrlForDeprecation]);
};

exports.useDeprecationMiddleware = useDeprecationMiddleware;
